import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Header, Footer } from './components/ui';
import Home from './pages/Home';
import QuemSomos from './pages/QuemSomos';
import ComoFunciona from './pages/ComoFunciona';
import ParaCorretoras from './pages/ParaCorretoras';
import Contato from './pages/Contato';

export default function App() {
  return (
    <HelmetProvider>
    <BrowserRouter>
      <div className="min-h-screen flex flex-col">
        <Header />
        <div className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/quem-somos" element={<QuemSomos />} />
            <Route path="/como-funciona" element={<ComoFunciona />} />
            <Route path="/para-corretoras" element={<ParaCorretoras />} />
            <Route path="/contato" element={<Contato />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </BrowserRouter>
    </HelmetProvider>
  );
}
